export default __webpack_public_path__ + "static/media/nutritionlogo.f648a87c.png";